<template>
  <div class="import-main">
    <Space wrap> </Space>
    <div class="header_top">
      <div class="import_btn">
        导入
        <input
          type="file"
          accept=".xls,.xlsx"
          class="upload_file"
          @change="readExcel($event)"
        />
      </div>
      <Button type="success" @click="toimage">获取图片地址</Button>
    </div>
    <Table :columns="columns" :data="lists" height="500"></Table>
    <div class="submit_box">
      <Poptip
        confirm
        title="是否将数据导入列表中?"
        @on-ok="onClickSubmit"
        @on-cancel="cancel"
      >
        <Button type="success">提交数据</Button>
      </Poptip>
    </div>
    <br />
    <br />
  </div>
</template>

<script>
import XLSX from "xlsx";
import Image from "@/views/device/image.vue";

export default {
  name: "",
  components: {
    Image,
  },
  props: {
    refListTable: {
      type: Function,
    },
  },
  data() {
    return {
      columns: [
        {
          title: "序号",
          key: "no",
          minWidth: 80,
          align: "left",
          copy: true,
        },
        {
          title: "错误描述",
          minWidth: 180,
          align: "left",
          key: "descr",
          viewimage: true,
        },
        {
          title: "资产名称",
          key: "facilityName",
          minWidth: 120,
          align: "center",
        },
        {
          title: "资产图片",
          minWidth: 120,
          align: "left",
          key: "facilityImg",
          viewimage: true,
          render: (h, params) => {
            const row = params.row;
            const text = row.facilityImg;
            return <img src={text} style="width: 100px;height:100px" />;
          },
        },
        {
          title: "资产分类",
          key: "type",
          minWidth: 100,
          align: "left",
        },
        {
          title: "SN码",
          minWidth: 90,
          align: "left",
          key: "sn",
        },
        {
          title: "资产型号",
          minWidth: 100,
          align: "left",
          key: "facilityType",
        },
        {
          title: "资产编号",
          key: "assetNum",
          minWidth: 120,
          align: "center",
        },
        {
          title: "购买日期",
          minWidth: 140,
          align: "left",
          key: "buyTime",
        },
        {
          title: "资产品牌",
          minWidth: 140,
          align: "left",
          key: "facilityBrand",
        },
        {
          title: "资产厂家",
          key: "manufacturer",
          minWidth: 140,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    display: "inline-block",
                    width: "100%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  },
                  domProps: {
                    title: params.row.manufacturer,
                  },
                },
                params.row.manufacturer
              ),
            ]);
          },
        },
        {
          title: "资产归属",
          key: "assetOwnership",
          minWidth: 120,
          align: "center",
        },
        {
          title: "资产安装时间",
          key: "installationTime",
          minWidth: 120,
          align: "center",
        },
        {
          title: "楼宇",
          key: "building",
          minWidth: 120,
          align: "center",
        },
        {
          title: "楼层",
          key: "floor",
          minWidth: 120,
          align: "center",
        },
        {
          title: "房间号",
          key: "room",
          minWidth: 120,
          align: "center",
        },
        {
          title: "核算科室",
          key: "checkDeskName",
          minWidth: 120,
          align: "center",
        },
        {
          title: "科室",
          key: "desk",
          minWidth: 120,
          align: "center",
        },
        {
          title: "ip/mac",
          key: "ipMac",
          minWidth: 120,
          align: "center",
        },
        {
          title: "资产状态",
          key: "status",
          minWidth: 120,
          align: "center",
        },
        {
          title: "创建人",
          key: "createBy",
          minWidth: 120,
          align: "center",
        },
        {
          title: "设备价值",
          key: "equipmentValue",
          minWidth: 120,
          align: "center",
        },

        // {
        //   title: '导入状态',
        //   key: 'state',
        //   minWidth: 100,
        //   align: 'center',
        //   fixed: 'right',
        //   render: (h, params) => {
        //     const row = params.row
        //     const text = row.state == 1 ? '成功' : row.state == 2 ? '失败' :row.state == 3 ? '重复':''
        //     return <span style={{ 'font-size': '14px', color: row.state == 1 ? '#12C3B5' : row.state == 2 ? 'red' :row.state == 3 ? '#ffb11b' : '' }}>{text}</span>
        //   },
        // },
      ],
      lists: [],
      oldList: [],
    };
  },
  computed: {},
  created() {},
  methods: {
    readExcel(e) {
      // 读取表格文件
      let that = this;
      const files = e.target.files;
      if (files.length <= 0) {
        return false;
      } else if (!/.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.$message({
          message: "上传格式不正确，请上传xls或者xlsx格式",
          type: "warning",
        });
        return false;
      } else {
        // 更新获取文件名
        that.upload_file = files[0].name;
      }
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary",
          });
          const wsname = workbook.SheetNames[0]; //取第一张表
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]) || []; //生成json表格内容
          that.lists = [];
          // 从解析出来的数据中提取相应的数据
          ws.forEach((item) => {
            // 1.先判断字符串是不是纯数字
            if (!isNaN(parseFloat(item["购买日期"]))) {
              //   //2.如果是纯数字 如果数字小于10万 那么就是日期格式 需要进行转换
              if (item["购买日期"] < 100000) {
                let time = new Date(
                  (item["购买日期"] - 25567) * 24 * 3600000 -
                    5 * 60 * 1000 -
                    43 * 1000 -
                    24 * 3600000 -
                    8 * 3600000
                );
                let year = time.getFullYear() + "-";
                let month = time.getMonth() + 1 + "-";
                let date = time.getDate() + "";
                item["购买日期"] = year + month + date;
              }
            }
            if (!isNaN(parseFloat(item["资产安装时间"]))) {
              if (item["资产安装时间"] < 100000) {
                //2.如果是纯数字 如果数字小于10万 那么就是日期格式 需要进行转换
                let time = new Date(
                  (item["资产安装时间"] - 25567) * 24 * 3600000 -
                    5 * 60 * 1000 -
                    43 * 1000 -
                    24 * 3600000 -
                    8 * 3600000
                );
                let year = time.getFullYear() + "-";
                let month = time.getMonth() + 1 + "-";
                let date = time.getDate() + "";
                item["资产安装时间"] = year + month + date;
              }
            }
            //否则直接返回
            that.lists.push({
              no: item["__rowNum__"] + 1,
              facilityName: item["资产名称"],
              assetOwnership: item["资产归属"],
              facilityImg: item["资产图片（地址）"],
              type: item["资产分类"],
              sn: item["SN码"],
              facilityType: item["资产型号"],
              buyTime: item["购买日期"],
              facilityBrand: item["资产品牌"],
              manufacturer: item["资产厂家"],
              building: item["楼宇"],
              floor: item["楼层"],
              room: item["房间号"],
              installationTime: item["资产安装时间"],
              checkDeskName: item["核算科室"],
              desk: item["科室"],
              status: item["资产状态"],
              ipMac: item["ip/mac"],
              createBy: item["创建人"],
              assetNum: item["资产编号"],
              equipmentValue: item["设备价值"],
              // state: 2,
            });
          });
          // 给后端发请求
        } catch (e) {
          return false;
        }
      };
      fileReader.readAsBinaryString(files[0]);
      e.target.value = "";
    },
    onClickSubmit() {
      if (this.lists.length == 0) {
        this.$Modal.remove();
        return;
      }
      this.$Spin.show({
        render: (h) => {
          return h("div", [
            h("Icon", {
              class: "demo-spin-icon-load",
              style: "animation: ani-demo-spin 1s linear infinite",
              props: {
                type: "ios-loading",
                size: 18,
              },
            }),
            h("div", "Loading"),
          ]);
        },
      });
      $utils.api
        .load(`/admin/system/facility/listFacility`, this.lists, "POST")
        .then((res) => {
          if (res.code == 200) {
            this.lists = res.data || [];
            this.oldList = res.data || [];
            let arr = res.successTotal || 0;
            $utils.toast.success(`导入成功`);
            this.refListTable();
            this.$Spin.hide();
            this.$Modal.remove();
          }
          if (res.code == 500) {
            this.lists = res.data || [];
            this.oldList = res.data || [];
            this.$Spin.hide();
          }
        })
        .catch((e) => {
          $utils.toast.error("导入异常" + e.message);
          this.$Spin.hide();
        });
    },
    toimage() {
      this.$Modal.remove();
      setTimeout(() => {
        this.$Modal.success({
          closable: true,
          title: "图片",
          width: 300,
          okText: "关闭",
          showOk: false,
          render: (h) => {
            return <Image style={{ margin: "0", color: "#19be6b" }}></Image>;
          },
        });
      }, 500);
    },
    //js XLSX读取 excel 转换日期格式
    getFormatDate_XLSX(serial) {
      var utc_days = Math.floor(serial - 25569);
      var utc_value = utc_days * 86400;
      var date_info = new Date(utc_value * 1000);
      var fractional_day = serial - Math.floor(serial) + 0.0000001;
      var total_seconds = Math.floor(86400 * fractional_day);
      var seconds = total_seconds % 60;
      total_seconds -= seconds;
      var hours = Math.floor(total_seconds / (60 * 60));
      var minutes = Math.floor(total_seconds / 60) % 60;
      var d = new Date(
        date_info.getFullYear(),
        date_info.getMonth(),
        date_info.getDate(),
        hours,
        minutes,
        seconds
      );
      //得到Date()对象后，便可进行日期格式化了！
      var add0 = (m) => (m < 10 ? "0" + m : m);
      var YYYY = d.getFullYear();
      var MM = add0(d.getMonth() + 1);
      var DD = add0(d.getDate());
      var hh = add0(d.getHours());
      var mm = add0(d.getMinutes());
      var ss = add0(d.getSeconds());
      return `${YYYY}-${MM}-${DD} ${hh}:${mm}:${ss}`;
    },
  },
};
</script>
<style lang="less" scoped>
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.header_top {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 20px;
}

.import_btn {
  width: 60px;
  height: 35px;
  border-radius: 10px;
  background-color: #fb9338;
  text-align: center;
  line-height: 35px;
  position: relative;
  color: #fff;

  .upload_file {
    opacity: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 100;
  }
}

.submit_box {
  // width: 100px;
  float: right;
  margin-top: 20px;
  margin-left: 15px;
}
</style>
